// Source/Sidenav-Toggle/Component.ts
class Sidenav_Toggle extends HTMLElement {
  constructor() {
    super();
    this.onToggle = this.onToggle.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.onToggle);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.onToggle);
  }
  onToggle() {
    const { sidebar } = this;
    this.classList.toggle("active");
    sidebar.ariaHidden = String(sidebar.ariaHidden !== "true");
  }
  get sidebar() {
    return document.querySelector(`#Navigation-Small-Container`);
  }
}

// Source/Sidenav-Toggle/mod.ts
customElements.define("sidenav-toggle", Sidenav_Toggle);
